import Phaser from 'phaser';
import { RENDER_SCALE } from '../config/rendering';

/**
 * Phaser 3.60+ removed the game-level `resolution` config property.
 * Each Text object renders at resolution 1 by default, causing blurriness
 * on high-DPI mobile screens. The game canvas is rendered at RENDER_SCALE,
 * and text textures use the same scale so they stay sharp after camera zoom.
 */
const TEXT_RESOLUTION = RENDER_SCALE;

export function ts(style: Phaser.Types.GameObjects.Text.TextStyle): Phaser.Types.GameObjects.Text.TextStyle {
  return { ...style, resolution: TEXT_RESOLUTION };
}
